import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(5.4696 5.4696)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Icon",
			d: "M13.0605 1.06055L7.59082 6.53027L13.0605 12L12 13.0605L6.53027 7.59082L1.06055 13.0605L0 12L5.46973 6.53027L0 1.06055L1.06055 0L6.53027 5.46973L12 0L13.0605 1.06055Z",
			fill: "currentColor"
		})
	})
});
export default SvgClose;
